import { Center, Paper, Stack, Text, ThemeIcon } from '@mantine/core';
import { PiTruck } from 'react-icons/pi';
import { TOffer } from '@/models/offers';
import CustomerSelectionsPanel from '../CustomerSelectionsPanel';
import SectionBanner from '../components/SectionBanner';

export default function DeliveryTab({ offer }: { offer: TOffer }) {
  if (!offer.customerSelections) {
    return (
      <Paper withBorder p="xl">
        <Center>
          <Stack align="center" gap="sm" maw={460}>
            <ThemeIcon size={56} radius="xl" variant="light" color="gray">
              <PiTruck size={28} />
            </ThemeIcon>
            <Text fw={600}>Delivery — coming soon</Text>
            <Text fz="sm" c="dimmed" ta="center">
              Once the client accepts and selects services, their selections
              appear here for Implementation Managers to commence operations and
              post updates against each deliverable. Per-installment
              implementation triggers will live here too.
            </Text>
          </Stack>
        </Center>
      </Paper>
    );
  }

  return (
    <Stack gap="md">
      <SectionBanner>
        Implementation Managers operate on each selected deliverable below —
        tracking readiness and posting operational updates per selection.
      </SectionBanner>
      <Paper withBorder p="sm" maw={760} data-testid="ux-delivery-panel">
        <CustomerSelectionsPanel selections={offer.customerSelections} />
      </Paper>
    </Stack>
  );
}
